import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@share';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { QuizService } from '../quiz/quiz.service';
import { LoadingService } from 'src/app/share/services/loading.service';
import { debounceTime, Subject, Subscription, forkJoin } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { QuizResultService } from '../quiz-result/quiz-result.service';
import { NzNotificationPlacement, NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-quiz-list',
  imports: [NzTagModule, NzDatePickerModule, NzToolTipModule, NzIconModule, NzDividerModule, NzPopconfirmModule, NzCardModule, NzTableModule, CommonModule, NzGridModule, FormsModule, NzButtonModule, NzButtonModule, FormsModule, NzInputModule, NzSelectModule, NzTreeModule, CommonModule, ReactiveFormsModule],
  templateUrl: './quiz-list.component.html',
  styleUrl: './quiz-list.component.scss'
})
export class QuizListComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private static readonly ACTION_TYPE_TO_PERMISSION_SUFFIX: { [type: string]: string } = {
    edit: 'edit',
    danger: 'delete',
    gen: 'edit'
  };
  private subscription: Subscription;
  loading = false;
  pageSize = 10;
  pageIndex = 1;
  private filterSubject = new Subject<void>();
  filters: { [key: string]: any } = {};
  listOfData: any[] = [];
  sorts: { [key: string]: any } = {};
  schema = {
    name: "Quiz List",
    permissionKey: "quizlist",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "10%"

      },
      {
        key: "name",
        title: "Name",
        type: "string",
        width: "20%",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
      },
      {
        key: "dateRange",
        title: "From ~ To Date",
        type: "datearray",
        enableSearch: true,
        searchType: "daterange",
        enableSort: false,
        width: "20%"
      },
      {
        key: "status",
        title: "Status",
        width: "20%",
        type: "tag",
        enableSearch: true,
        searchType: "select",
        option: [
          { value: "draft", text: "Draft" },
          { value: "published", text: "Published" }
        ],
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        label: [
          { name: "edit", type: "edit", isDanger: false, isEnable: true },
          { name: "Generate", type: "gen", isDanger: false, isEnable: true },
          { name: "delete", type: "danger", isEnable: true }
        ]
      }
    ]
  };
  total = 0;
  confirmModal?: NzModalRef; 

  constructor(private modal: NzModalService, private notiService:NzNotificationService, private readonly modalService: NzModalService,private service: QuizService, private loadingService: LoadingService,private router: Router,private readonly quiz_result_service:QuizResultService) {

  }
  ngOnInit(): void {
    this.subscription = this.loadingService.isVisible$.subscribe(value => {
      this.loading = value;
    });
    
    forkJoin({
      quizzes: this.service.getItems()
    })
      .subscribe({
        next: ({ quizzes }) => {
        
          this.schema.columns[1].option = quizzes?.data.map((y: any) => ({
            text: y.name,
            value: y.name
          })).filter((item: any, index: number, self: any[]) => 
            index === self.findIndex((t: any) => t.text === item.text && t.text)
          );
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
          this.filterSubject.pipe(debounceTime(500)).subscribe(() => {
            this.emitFilterChange();
          });
          this.filters = this.schema.columns.reduce((acc: { [key: string]: string }, x: any) => {
            acc[x.key] = null;
            return acc;
          }, {});
        }
      });
  }

  onPageIndexChange(pageIndex: number): void {
    this.loading = true;
    this.pageIndex = pageIndex;
    this.listOfData = [];
    let params = new HttpParams()
      .set('page', this.pageIndex.toString())
      .set('pageSize', this.pageSize.toString())
      .set('filterValue', JSON.stringify(this.filters))
      .set('sort', JSON.stringify(this.sorts));
    this.loadData(params);
  }

  onPageSizeChange(pageSize: number): void {
    this.loading = true;
    this.pageSize = pageSize;
    this.listOfData = [];
    let params = new HttpParams()
      .set('page', this.pageIndex.toString())
      .set('pageSize', this.pageSize.toString())
      .set('filterValue', JSON.stringify(this.filters))
      .set('sort', JSON.stringify(this.sorts));
    this.loadData(params);
  }

  onFilterChange(): void {
    this.filterSubject.next();
  }

  emitFilterChange(): void {
    this.pageIndex = 1;
    this.pageSize = this.schema.pageSize;
    let params = new HttpParams()
      .set('page', this.pageIndex.toString())
      .set('pageSize', this.pageSize.toString())
      .set('filterValue', JSON.stringify(this.filters))
      .set('sort', JSON.stringify(this.sorts));
    this.loadData(params);
    //let obj = { "sorts": this.sorts, "type": 'sort', filters: this.filters, pageIndex: this.pageIndex, pageSize: this.pageSize };
  }

  loadData(params: any) {
    this.loadingService.toggleTableLoading();
    this.service.getItems(params).subscribe({
      next: (x: any) => {
        this.listOfData = x.data;
        this.total = x.totalCount;
      },
      error: (err: any) => { console.log(err); this.loadingService.toggleTableLoading(); },
      complete: () => {
        this.loadingService.toggleTableLoading();
      }
    })
  }

  getSerialNo(index: number): number {
    return (this.pageIndex - 1) * this.pageSize + index + 1;
  }

  canShowAdd(): boolean {
    if (!this.schema?.enableAdd) {
      return false;
    }
    return this.hasActionPermission('add');
  }

  canShowLabel(label: { type?: string; isEnable?: boolean }): boolean {
    if (!label?.isEnable) {
      return false;
    }
    const suffix = QuizListComponent.ACTION_TYPE_TO_PERMISSION_SUFFIX[label.type ?? ''];
    if (!suffix) {
      return true;
    }
    return this.hasActionPermission(suffix);
  }

  private hasActionPermission(suffix: string): boolean {
    const permissionKey = (this.schema as any)?.permissionKey;
    if (!permissionKey) {
      return true;
    }
    return this.authService.hasPermission([`${permissionKey}.${suffix}`]);
  }

  onAdd() {
    this.router.navigate(['/quizlist/quiz']);
  }

  onEdit(data: any) {
    this.router.navigate(['/quizlist/quiz',data.id]);
  }

  onGenerateResult(data:any){
     this.loadingService.toggleTableLoading();
      this.modalService.confirm({
        nzTitle: `Are you sure want to generate winner for ${data.name}?`,
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.quiz_result_service.generateWinner(data.id).subscribe({
            next: x => {
              console.log(x);
            },
            error: err => {console.log(err);this.loadingService.toggleTableLoading();},
            complete:()=> {
              this.loadingService.toggleTableLoading();
              this.notiService.blank(
      'Success',
      'Successfully generated quiz winners!.',
      { nzPlacement: 'topRight' }
    );

            }
          });
        },
        nzOnCancel: () => {
          this.loadingService.toggleTableLoading();
        }
      });
  }

  onDelete(data: any) {
    this.loadingService.showLoading();
    this.service.deleteItem({deleted_id:data.id}).subscribe({
      next:(value:any)=>{
        let params = new HttpParams()
        .set('page', this.schema.pageIndex.toString())
        .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      },
      error:(err:any)=>{
        this.loadingService.hideLoading();
      },
      complete:()=>{
        this.loadingService.hideLoading();
      }
    })
  }

  showConfirm(data:any): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: 'Do you Want to delete this item?',
      nzContent: 'When clicked the OK button, that item will delete.',
      nzOnOk: () =>
        // new Promise((resolve, reject) => {
        //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        // }).catch(() => console.log('Oops errors!'))
        this.onDelete(data)
    });
  }

  
  getTagColor(value: string): string {
    if (value == 'published') return 'green';
    return 'default'; // Default color for unknown permissions
  }

}
